let _ = t => t,
    _t;

import { CANDY_APPLE_LIGHT, OLAF, SLINKY } from 'HubStyleTokens/colors';
import { createGlobalStyle } from 'styled-components';
import { cookieBannerDevices } from '../styles/viewports.styles';
const colorBackgroundSolidWhiteHover = `rgba(${OLAF}, 0.9)`;
const colorHighContrast = '#1d0cff';
const fontWeightLight = 300;
const fontWeightBold = 500;
const _fontFamilyLexendDeca = `'Lexend Deca', 'LexendDeca', 'AvenirNext', 'Helvetica Neue', helvetica, arial, sans-serif`;
const buttonTransition = '0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out !important';
export const GlobalStyle = createGlobalStyle(_t || (_t = _`
  html {
    min-height: 100%;
  }
  body {
    min-height: 100% !important;
    font-size: 17px !important;
    background-color: ${0};

    small {
      font-size: 14px !important;
    }
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  .hsg-notice {
    padding: 20px;
    background-color: ${0};
    opacity: 0.83;
    margin-bottom: 15px;
    text-align: center;
  }

  body:not([class*="cookie-banner-"]) {
    #hs-eu-cookie-confirmation {
      display: none !important;
    }
  }


  .cookie-banner-top-static {
    padding-top: 0.1px;
    #hs-eu-cookie-confirmation {
      position: static !important;
      z-index: 10;
      width: 100% !important;
    }
  }
  .cookie-banner-hidden {
    #hs-eu-cookie-confirmation {
      display: none !important;
    }
  }

  div#hs-eu-cookie-confirmation {
    background-image: none !important;
    text-shadow: none !important;
    border-radius: 0 !important;
    width: 100vw !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    transform: none !important;

    div#hs-eu-cookie-confirmation-inner a {
      text-decoration: underline !important;
      font-weight: ${0} !important;
      font-family: ${0} !important;
    }

    div#hs-eu-cookie-confirmation-inner p,
    #hs-eu-policy-wording {
      font-size: 0.9rem !important;
      font-weight: ${0} !important;
      line-height: 1.2rem !important;
      font-family: ${0} !important;
      margin: 0 0 16px !important;
      padding: 0 !important;
      margin-right: 0 !important;
      text-align: left !important;

      a {
        line-height: inherit !important;
      }

      a.contrast {
        color: ${0} !important;
      }

      a:hover {
        text-decoration: underline !important;
      }
    }

    #hs-eu-cookie-confirmation-inner {
      padding: 0.9rem 2rem !important;
    }

    #hs-eu-cookie-confirmation-buttons-area {
      display: flex !important;
      margin-right: inherit !important;
      margin-top: 0 !important;
      position: relative !important;
    }
  }

  &.hs-banner-parent-sticky {
    position: sticky !important;
    z-index: 99999;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;

    div#hs-eu-cookie-confirmation {
      position: sticky !important;

      .hs-eu-cookie-close-button {
        position: absolute;
        top: 2%;
        right: 0.5%;
        font-size: 2.5rem !important;
        transition: 0.15s color ease-out !important;
        text-decoration: none !important;
        padding: 2px 5px 7px !important;

        button {
          border: 0 !important;
          background-color: transparent;
          cursor: pointer;
        }

        &:hover,
        &:focus {
          text-decoration: none !important;
        }
      }

      #hs-eu-policy-wording {
        border-bottom: 2px solid ${0};

        @media ${0} {
          p {
            margin-right: 1rem !important;
          }
        }

        @media ${0} {
          p {
            margin-right: 0 !important;
          }
        }
      }

      div#hs-eu-cookie-confirmation-inner {
        button#hs-eu-cookie-settings-button {
          font-family: ${0} !important;
          font-weight: 500 !important;
          text-decoration: none !important;
          position: absolute !important;
          left: 0 !important;
          top: 50% !important;
          transform: translateY(-50%) !important;

          &:hover {
            text-decoration: underline !important;
          }

          @media ${0} {
            position: relative !important;
            left: auto !important;
            top: auto !important;
            transform: none !important;
            border-bottom: none !important;
            order: 4;
            padding: 0 !important;
          }
        }
      }

      #hs-eu-cookie-confirmation-buttons-area {
        place-content: flex-end !important;
      }

      button#hs-eu-confirmation-button {
        order: 2;
      }

      @media ${0} {
        div#hs-eu-cookie-confirmation-inner {
          padding-top: 0 !important;
        }

        .hs-eu-cookie-close-button {
          position: relative;
          top: auto;
          right: auto;
          padding: 0.5rem 0 0 !important;
          display: flex;
          place-content: flex-end;
        }
      }
    }

    &.banner-visually-hidden {
      border: 0;
      clip: rect(0, 0, 0, 0);
      height: 1px;
      overflow: hidden;
      padding: 0;
      width: 1px;
    }
  }

  #hs-eu-cookie-confirmation-inner {
    box-sizing: content-box !important;
    margin: 0 auto !important;
    max-width: 1080px !important;
    padding: 1.25rem 2rem !important;
    #hs-eu-cookie-confirmation-buttons-area {
      button#hs-eu-confirmation-button,
      button#hs-eu-decline-button {
        border: 0 !important;
        border-radius: 0.1875rem !important;
        box-shadow: none !important;
        display: inline-block !important;
        line-height: 1.25 !important;
        padding: 0.75rem 1.5rem !important;
        text-shadow: none !important;
        transition: ${0};
        font-family: ${0} !important;
        height: 3em !important;
        font-weight: 500 !important;
        &:hover {
          background-color: ${0} !important;
          text-decoration: underline !important;
        }
      }
    }

  }
`), OLAF, CANDY_APPLE_LIGHT, fontWeightBold, _fontFamilyLexendDeca, fontWeightLight, _fontFamilyLexendDeca, colorHighContrast, SLINKY, cookieBannerDevices.large, cookieBannerDevices.medium, _fontFamilyLexendDeca, cookieBannerDevices.small, cookieBannerDevices.medium, buttonTransition, _fontFamilyLexendDeca, colorBackgroundSolidWhiteHover);